import PreorderProduct from '../../models/PreorderProduct'
import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'


export interface PreorderAllProductListState extends PaginatedApiState {
  preorderAllProducts?: PreorderProduct[] 
}

const PreorderAllProductList = (state: PreorderAllProductListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<PreorderAllProductListState>('PREORDER_ALL_PRODUCT_LIST')(state, action)
  }
}

export default PreorderAllProductList
